import React, { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useTranslation } from 'next-i18next'
import parse from 'html-react-parser'

import { css } from '@emotion/react'

import { AxiosError } from 'axios'

import { mediaUp } from '@/styles/media'
import { Text1 } from '@/styles/typography'

import Title from '@/components/common/Title'
import Button from '@/components/common/Button'

import api from '@/service'

import { first } from '@/utils/common'

import EmailController from '@/components/landing/EmailController2'
import ConsentController from '@/components/landing/ConsentController2'

import { SubscribersFormType } from '@/components/landing/type'

interface Props {
  buttonText?: string
  thankYouContent?: React.ReactNode
  onClick?(value: boolean): void
}

function Form2(props: Props) {
  const { onClick, buttonText, thankYouContent } = props
  const { t } = useTranslation(['common', 'landing'])
  const [sended, setSended] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const form = useForm<SubscribersFormType>({
    mode: 'onTouched'
  })
  const formEmail = form.watch('email')
  const formConsent = form.watch('consent')
  const disabled = formEmail && formConsent

  const onSubmit: SubmitHandler<SubscribersFormType> = data => {
    const { email } = data

    if (loading) return
    setLoading(true)
    setError('')

    return api.newsletter
      .subscribe({ email })
      .then(() => {
        setSended(true)
        onClick && onClick(true)
      })
      .catch(err => {
        const response = err.response as AxiosError['response']
        const error =
          //@ts-ignore
          first(response?.data?.errors) || t('common:contact.form.error')
        setError(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <>
      {!sended && (
        <form onSubmit={form.handleSubmit(onSubmit)} css={container}>
          <EmailController control={form.control} />
          <ConsentController form={form} />

          {error && <Text1>{parse(error)}</Text1>}

          <Button
            type="submit"
            text={buttonText ? buttonText : t('landing:button.notifyMe')}
            loading={loading}
            disabled={loading || !disabled}
            css={button}
            style="green"
          />
        </form>
      )}
      {sended && (
        <div css={container}>
          {thankYouContent ? (
            thankYouContent
          ) : (
            <Title light text={t('landing:burjuman.form.thanks')} />
          )}
        </div>
      )}
    </>
  )
}

const container = css`
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;

  ${mediaUp('md')} {
    margin-top: 0;
  }
`

const button = css`
  margin: 18px auto 0;

  ${mediaUp('lg')} {
    margin-top: 40px;
  }
`

export default Form2
